<template >
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :xl="22" :lg="22" :offset="1" class="page-title-stakeholder">{{pageTitle}}</el-col>
      <el-col :xl="3" :lg="4" :offset="1" class="margin-top margin-bottom">
        <!-- search Questionnaire -->
        <el-form label-position="top" :model="assessmentResultInfo" ref="searchForm">
          <el-form-item label="Year">
            <el-select v-model="assessmentResultInfo.year">
              <el-option
                v-for="(item, index) in yearListSearch"
                :key="index"
                :label="item.yearName"
                :value="item.yearValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Category">
            <el-select v-model="assessmentResultInfo.category">
              <el-option
                v-for="(item, index) in categoryListForSearch"
                :key="index"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Organization">
            <el-input v-model="assessmentResultInfo.organization"></el-input>
          </el-form-item>
          <el-form-item label="Region">
            <el-select v-model="assessmentResultInfo.region">
              <el-option
                v-for="(item, index) in regionListSearch"
                :key="index"
                :label="item.regionName"
                :value="item.regionValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Staff">
            <el-input v-model="assessmentResultInfo.stakeholderName"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email" :rules="[{ type: 'email', message: incorrectEmailMsg, trigger: ['blur', 'change'] }]">
           <el-input v-model="assessmentResultInfo.email" onKeypress="if(event.keyCode == 32) event.returnValue = false"></el-input>
          </el-form-item>
          <el-form-item label="Company">
            <el-select v-model="assessmentResultInfo.company">
              <el-option
                v-for="(item, index) in companyListSearch"
                :key="index"
                :label="item.companyName"
                :value="item.companyValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Associated Staff">
            <el-input v-model="assessmentResultInfo.applicant"></el-input>
          </el-form-item>
          <el-form-item label="Status">
            <el-select v-model="assessmentResultInfo.status">
              <el-option
                v-for="(item, index) in statusObjects"
                :key="index"
                :label="item"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="danger" class="search-btn" @click="handleSearchAssessmentResult">{{buttonSearch}}</el-button>
      </el-col>
      <el-col :xl="1" :lg="1" class="margin-top">
        <div class="line"></div>
      </el-col>
      <!-- Export excel -->
      <el-col :xl="18" :lg="17" class="margin-top">
        <el-button @click="handleRemind">Remind</el-button>
        <el-button @click="handleRemindAll">Remind All</el-button>
        <el-button @click="exportTableData">{{buttonExport}}</el-button>
        <el-button @click="exportDialogVisible = true">Report</el-button>
        <!-- Questionnaire table  -->
        <el-table class="stakeholder-table"
                  empty-text="No Data"
                  :data="dataSource"
                  :default-sort="{prop: 'year', order: 'descending'}"
                  stripe
                  max-height="700"
                  style="width: 100%"
                  v-loading="loadingStatus"
                  @selection-change="handleSelectionChange"
                  highlight-current-row>
          <el-table-column type="selection" >
          </el-table-column>
          <el-table-column label="Year" width="100px" align="center" prop="year">
            <template slot-scope="scope">
              <span>{{scope.row.year}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Questionnaire Name" width="200px" align="center">
            <template slot-scope="scope">
              <span @click="gotoResultDetail(scope.row.answerAssessmentId, scope.row.assessmentId)"><a href="javascript:void(0)">{{scope.row.assessmentNo}}</a></span>
            </template>
          </el-table-column>
          <el-table-column label="Category" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.category}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Organization" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.organization}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Region" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.region}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Staff" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.userName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Email" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.email}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Company" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.company}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Associated Staff" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.applicant}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.status}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="table-nav"
                       background
                       ref="multipleTable"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[20,40, 100, 200, 500]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
        <el-dialog title="Export Stakeholder Questionnaire Report" :visible.sync="exportDialogVisible" width="30%" center>
          <span>Please select the year for the report.</span>
          <div style="margin-top: 15px;">
            <el-select v-model="exportYear" placeholder="Please select">
              <el-option v-for="(item, index) in exportYearObject" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" slot="trigger" size="small" plain @click="exportDialogVisible = false">Cancel</el-button>
            <el-button type="danger" slot="trigger" size="small" plain @click="handleExportReport">Export</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-col>
    <Footer v-on:init="init"></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue'
import {findQuestionnaireResult, findQuestionnaireResultByConditions, findSearchConditions, callSendRemindEmail, remindAllStakeholder, callGenerateExcel} from '@/services/answerer/questionnaire.service'
import { findAllCategory } from '@/services/stakeholderCategory.service';
// import { remindAllStakeholder } from '@/services/email.service';
import Constant from '@/common/Constant';

export default {
  components: {
    Footer,
    Header
  },
  data () {
    return {
      dataSource: [],
      assessmentResultInfo: {
        year: '',
        assessmentNo: '',
        email: '',
        applicant: '',
        stakeholderName: '',
        company: '',
        region: '',
        status: '',
        organization: '',
        category: '',
        userType: Constant.TYPE_STAKEHOLDER,
        currentPage: 1,
        pageSize: 20
      },
      rules: {
        email: [
          { required: true, message: Constant.INPUT_EMAIL, trigger: 'blur' },
          { type: 'email', message: Constant.ENTER_CORRECT_EMAIL, trigger: ['blur', 'change'] }
        ]
      },
      userType: Constant.TYPE_STAKEHOLDER,
      incorrectEmailMsg: Constant.ENTER_CORRECT_EMAIL,
      yearListSearch: [],
      exportYearObject: {},
      companyListSearch: [],
      regionListSearch: [],
      statusObjects: {},
      categoryListForSearch: [],
      currentPage: 1,
      pageSize: 20,
      pageTitle: '',
      totalCount: 0,
      buttonSearch: '',
      buttonExport: '',
      loadingStatus: false,
      multipleSelection: [],
      exportDialogVisible: false,
      exportYear: ''
    }
  },
  methods: {
    handleSelectionChange (value) {
      this.multipleSelection = value;
    },
    handleRemind () {
      // var hasCompleted = false;
      let answerAssessmentIds = [];
      if (this.multipleSelection.length === 0) {
        this.$message.warning(Constant.SELECT_NONE_LINE_REMIND);
      } else {
        var info = Constant.MESSAGE_SEND_REMIND_EMAIL_TEXT_CONFIRM;
        var flag = false;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].status !== Constant.ANSWER_STATUS_COMPLETED && this.multipleSelection[i].unsubscribed !== '1' && this.multipleSelection[i].active !== '0') {
            answerAssessmentIds.push(this.multipleSelection[i].answerAssessmentId)
          }
          if (!flag && this.multipleSelection[i].status === Constant.ANSWER_STATUS_COMPLETED) {
            flag = true;
            info = Constant.MESSAGE_SEND_REMIND_EMAIL_TEXT;
          }
        }
        this.$confirm(info, Constant.MESSAGE_CONFIRM_WARNING_TITLE, {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'Warning'
        }).then(() => {
          this.sendRemindEmail(answerAssessmentIds);
        }).catch(cancel => {
          console.log('Cancel');
        });
      }
    },
    async sendRemindEmail (answerAssessmentIds) {
      let content = this.$store.state.dictionary[1].REMIND_STAKEHOLDER_CONFIRM;
      await callSendRemindEmail(answerAssessmentIds).then(value => {
        this.$alert(content, {
          confirmButtonText: 'OK'
        })
      });
    },
    handleRemindAll () {
      this.$confirm(Constant.MESSAGE_SEND_REMIND_EMAIL_TEXT, Constant.MESSAGE_CONFIRM_WARNING_TITLE, {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'Warning'
      }).then(() => {
        this.remindAllStakeholder();
      }).catch(cancel => {
        console.log('Cancel');
      });
    },
    async remindAllStakeholder () {
      let content = this.$store.state.dictionary[1].REMIND_STAKEHOLDER_CONFIRM;
      this.assessmentResultInfo = JSON.parse(sessionStorage.getItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS));
      await remindAllStakeholder(this.assessmentResultInfo).then(value => {
        this.$alert(content, {
          confirmButtonText: 'OK'
        })
      });
    },
    gotoResultDetail (answerAssessmentId, assessmentId) {
      let {href} = this.$router.resolve({name: 'QuestionnaireResultDetail', query: {userType: this.userType, assessmentId: assessmentId, answerAssessmentId: answerAssessmentId}});
      window.open(href, '_blank');
    },
    async findAssessmentResult () {
      this.$loading({fullscreen: true});
      let searchConditions = await findSearchConditions(0);
      let categoryInfo = await findAllCategory();
      this.initSearchCondition(searchConditions.data, categoryInfo.data);
      this.$loading({fullscreen: true}).close();
    },
    initSearchCondition (searchConditions, categoryInfo) {
      let statusSet = new Set();
      let yearSet = new Set();
      let regionSet = new Set();
      let companySet = new Set();
      let categorySet = new Set();
      searchConditions.regions.forEach(item => {
        if (item !== '' && item !== null) {
          regionSet.add(item);
        }
      });
      searchConditions.companies.forEach(item => {
        if (item !== '' && item !== null) {
          companySet.add(item);
        }
      });
      searchConditions.year.forEach(item => {
        if (item !== '' && item !== null) {
          yearSet.add(item);
        }
      });
      categoryInfo.forEach(item => {
        if (item.categoryName !== '' && item.categoryName !== null) {
          categorySet.add(item.categoryName);
        }
      });
      statusSet.add(Constant.ANSWER_STATUS_COMPLETED);
      statusSet.add(Constant.ANSWER_STATUS_INPROGRESS);
      statusSet.add(Constant.ANSWER_STATUS_SENT);
      // region dropdown
      let tempRegionObjects = {};
      regionSet.forEach(it => {
        tempRegionObjects[it] = it;
      });
      let regionForAll = {
        regionValue: '',
        regionName: '<ALL>'
      };
      this.regionListSearch.push(regionForAll);
      Object.keys(tempRegionObjects).sort().forEach(item => {
        let region = {
          regionValue: item,
          regionName: item
        };
        this.regionListSearch.push(region);
      });
      // company dropdown
      let tempCompanyObjects = {};
      companySet.forEach(it => {
        tempCompanyObjects[it] = it;
      });
      let companyForAll = {
        companyValue: '',
        companyName: '<ALL>'
      };
      this.companyListSearch.push(companyForAll);
      Object.keys(tempCompanyObjects).sort().forEach(item => {
        let company = {
          companyValue: item,
          companyName: item
        };
        this.companyListSearch.push(company);
      });
      // status dropdown
      let tempStatusObjects = {};
      statusSet.forEach(it => {
        tempStatusObjects[it] = it;
      });
      this.statusObjects[''] = '<ALL>';
      Object.keys(tempStatusObjects).sort().forEach(item => {
        this.statusObjects[item] = item;
      });
      // year dropdown
      let tempYearObjects = {};
      yearSet.forEach(it => {
        tempYearObjects[it] = it;
      });
      let yearForAll = {
        yearValue: '',
        yearName: '<ALL>'
      };
      this.yearListSearch.push(yearForAll);
      Object.keys(tempYearObjects).sort().forEach(item => {
        let year = {
          yearValue: item,
          yearName: item
        };
        this.yearListSearch.push(year);
        this.exportYearObject[item] = item;
        // to get the last value
        this.exportYear = item;
      });
      // category dropdown
      let tempCategoryObjects = {};
      categorySet.forEach(it => {
        tempCategoryObjects[it] = it;
      });
      let categoryForAll = {
        categoryId: '',
        categoryName: '<ALL>'
      };
      this.categoryListForSearch.push(categoryForAll);
      Object.keys(tempCategoryObjects).sort().forEach(item => {
        let category = {
          categoryId: item,
          categoryName: item
        };
        this.categoryListForSearch.push(category);
      });
    },
    handleSearchAssessmentResult () {
      this.pageSize = 20;
      this.currentPage = 1;
      this.assessmentResultInfo.pageSize = 20;
      this.assessmentResultInfo.currentPage = 1;
      this.$refs.searchForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          sessionStorage.setItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
          this.callSearchAssessmentResult();
        }
      });
    },
    async callSearchAssessmentResult () {
      this.loadingStatus = true;
      let AssessmentResultDto = JSON.parse(sessionStorage.getItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS));
      let ResultData = await findQuestionnaireResultByConditions(AssessmentResultDto);
      this.dataSource = ResultData.data.assessmentResultVos;
      this.totalCount = ResultData.data.totalCount;
      this.loadingStatus = false;
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.assessmentResultInfo = JSON.parse(sessionStorage.getItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS));
      this.assessmentResultInfo.pageSize = val;
      sessionStorage.setItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
      this.callSearchAssessmentResult();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.assessmentResultInfo = JSON.parse(sessionStorage.getItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS));
      this.assessmentResultInfo.currentPage = val;
      sessionStorage.setItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
      this.callSearchAssessmentResult();
    },
    init () {
      this.buttonExport = this.$store.state.dictionary[1].BUTTON_EXPORT;
      this.buttonSearch = this.$store.state.dictionary[1].BUTTON_SEARCH;
      this.pageTitle = this.$store.state.dictionary[1].RESULT_QUESTIONNAIRE_TITLE;
    },
    async exportTableData () {
      this.$loading({fullscreen: true});
      let dataSource = await findQuestionnaireResult();
      require.ensure([], () => {
        const { exportJsonToExcel } = require('@/utils/Export2Excel');
        let tHeader = Constant.STAKEHOLDER_EXCEL_HEADER;
        let filterVal = Constant.STAKEHOLDER_EXCEL_CONTENT;
        let list = dataSource.data;
        let data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, 'StakeholderQuestionnaireResult');
      });
      this.$loading({fullscreen: true}).close();
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    handleExportReport () {
      this.generateExcelForUser();
    },
    async generateExcelForUser () {
      let content = this.$store.state.dictionary[1].REMIND_STAKEHOLDER_CONFIRM;
      let response = await callGenerateExcel(this.exportYear);
      if (response.msg === null && response.code === 'SUCCESS') {
        this.$alert(content, {
          confirmButtonText: 'OK'
        });
      }
      this.exportDialogVisible = false;
    }
  },
  mounted () {
    this.$loading({fullscreen: true});
    sessionStorage.setItem(Constant.QUESTIONNAIRE_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
    this.findAssessmentResult().then(value => {
      this.callSearchAssessmentResult();
    });
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
};
</script>

<style scoped>
    .text-align-left {
      text-align: left;
    }

    .page-title-stakeholder {
      font-size: 20px;
      margin-top: 80px;
    }

    .margin-top {
      margin-top: 30px;
    }

    .margin-bottom {
      margin-bottom: 45px;
    }

    .line {
      width: 1px;
      height: 700px;
      background-color: #e6e6e6;
      margin-left: 20px;
    }

    .stakeholder-table {
      margin-top: 15px;
    }

    .table-nav {
      position: fixed;
      bottom: 40px;
    }

    .search-btn {
      margin-top: 20px !important;
      width: 200px;
    }

    >>>.el-button{
      border-color: #5e89ed;
      color: #5e89ed;
    }

    >>>.el-button:hover{
      border-color: #5e89ed;
      background-color: #5e89ed;
      color: #fff;
    }

    >>>.el-button:focus{
      border-color: #5e89ed;
      background-color: #5e89ed;
      color: #fff;
    }

    >>>.el-button--danger{
      background-color: #5e89ed;
      border-color: #5e89ed;
      color: #fff;
    }

    >>>.el-button--danger:hover{
      background-color: #4b6ebe;
      border-color: #4b6ebe;
      color: #fff;
    }

    >>>.el-button--danger:focus{
      background-color: #4b6ebe;
      border-color: #4b6ebe;
      color: #fff;
    }

    >>>.el-table{
      color: black;
    }

    >>>.el-table thead{
      color: black;
    }

    .el-input{
      margin-top: 0;
      width: 200px;
    }

    >>>.el-form--label-top .el-form-item__label{
      padding: 0;
    }

    >>>.el-form-item{
      margin-bottom: 5px;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #5e89ed;
      border-color: #5e89ed;
    }

    >>>.el-pager li.active{
      color: #5e89ed;
    }

    >>>.el-pager li:hover{
      color: #5e89ed;
    }

    >>>.el-checkbox__inner{
      border: 1px solid #aaaaaa;
    }

    >>>.el-form-item__label{
      line-height: 32px;
    }
    >>>.upload-content {
      padding-top: 30px;
    }
</style>
<style>
  .el-input {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/StakeholderQuestionnaireResult.vue